'use client';
import { Flex } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import React, { useState, useEffect } from 'react';
import NextImage from 'next/image';
import { CurrencyIcons } from '@/constants/currency/currency';
import type { Country } from '@/constants/country/country';
import { useRegionCurrency } from '@/contexts/regionCurrencyContext';

const COUNTRY_BUTTON_TEST_ID = 'country-button';

type CountryButtonProps = ComponentProps<typeof Flex>;

const CountryButton = ({ ...rest }: CountryButtonProps) => {
  const { country } = useRegionCurrency();

  const [displayCountry, setDisplayCountry] = useState<Country>(country);

  useEffect(() => {
    setDisplayCountry(country);
  }, [country]);

  return (
    <>
      <Flex
        as="button"
        asChild
        cursor="pointer"
        data-testid={COUNTRY_BUTTON_TEST_ID}
        minWidth="24px"
        minHeight="24px"
        {...rest}
      >
        <NextImage
          alt={`${displayCountry} flag`}
          height={24}
          width={24}
          src={CurrencyIcons[displayCountry]}
          style={{ borderRadius: '50%' }}
        />
      </Flex>
    </>
  );
};

export default CountryButton;
